import _slicedToArray from "/Users/jakubpsenda/jakub/projekty/projekty/gatsby_martin_github/video/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/Users/jakubpsenda/jakub/projekty/projekty/gatsby_martin_github/video/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["eventKey", "disabled", "onClick", "active", "as"];

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import * as React from 'react';
import { useContext } from 'react';
import useEventCallback from '@restart/hooks/useEventCallback';
import SelectableContext, { makeEventKey } from './SelectableContext';
import NavContext from './NavContext';
import Button from './Button';
import { dataAttr } from './DataKey';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Create a dropdown item. Returns a set of props for the dropdown item component
 * including an `onClick` handler that prevents selection when the item is disabled
 */

export function useDropdownItem(_ref2) {
  var key = _ref2.key,
      href = _ref2.href,
      active = _ref2.active,
      disabled = _ref2.disabled,
      onClick = _ref2.onClick;
  var onSelectCtx = useContext(SelectableContext);
  var navContext = useContext(NavContext);

  var _ref3 = navContext || {},
      activeKey = _ref3.activeKey;

  var eventKey = makeEventKey(key, href);
  var isActive = active == null && key != null ? makeEventKey(activeKey) === eventKey : active;
  var handleClick = useEventCallback(function (event) {
    if (disabled) return;
    onClick == null ? void 0 : onClick(event);

    if (onSelectCtx && !event.isPropagationStopped()) {
      onSelectCtx(eventKey, event);
    }
  });
  return [_defineProperty({
    onClick: handleClick,
    'aria-disabled': disabled || undefined,
    'aria-selected': isActive
  }, dataAttr('dropdown-item'), ''), {
    isActive: isActive
  }];
}
var DropdownItem = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var eventKey = _ref.eventKey,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      active = _ref.active,
      _ref$as = _ref.as,
      Component = _ref$as === void 0 ? Button : _ref$as,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  var _useDropdownItem = useDropdownItem({
    key: eventKey,
    href: props.href,
    disabled: disabled,
    onClick: onClick,
    active: active
  }),
      _useDropdownItem2 = _slicedToArray(_useDropdownItem, 1),
      dropdownItemProps = _useDropdownItem2[0];

  return /*#__PURE__*/_jsx(Component, Object.assign({}, props, {
    ref: ref
  }, dropdownItemProps));
});
DropdownItem.displayName = 'DropdownItem';
export default DropdownItem;